import styled from '@emotion/styled';
import { Spacings, Fonts, mediaQuery } from '@styles/index';
import Typography from 'aquilla/core/atoms/Typography';
import Image from '@base/FutureImage';
import CentreItem from './CentreItem';

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

const Container = styled.div`
  width: 1156px;
  padding-top: ${Spacings.SPACING_20B};
  ${mediaQuery.uptoMobile} {
    width: 100%;
    padding: ${Spacings.SPACING_12B} ${Spacings.SPACING_4B} 0px
      ${Spacings.SPACING_4B};
  }
  ${mediaQuery.uptoTablet} {
    width: 100%;
    padding: ${Spacings.SPACING_12B} ${Spacings.SPACING_4B} 0px
      ${Spacings.SPACING_4B};
  }
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-left: ${Spacings.SPACING_3B};
  gap: ${Spacings.SPACING_2B};
  ${mediaQuery.uptoMobile} {
    margin-left: 0px;
  }
`;

const LocationButtonContainer = styled.div`
  width: 320px;
  height: ${Spacings.SPACING_10B};
  display: flex;
  flex-direction: row;
  border-radius: ${Spacings.SPACING_2B};
  align-items: center;
  margin-left: ${Spacings.SPACING_3B};
  gap: ${Spacings.SPACING_2B};
  cursor: pointer;
  background-color: var(--color-i-blue-48);
  margin-top: ${Spacings.SPACING_6B};
  overflow: hidden;
  position: relative;
  padding: ${Spacings.SPACING_4B} ${Spacings.SPACING_8B} ${Spacings.SPACING_4B}
    ${Spacings.SPACING_8B};
  ${mediaQuery.uptoMobile} {
    width: 100%;
    margin-top: ${Spacings.SPACING_4B};
    margin-left: 0px;
  }
`;

const LocationButtonTextWrapper = styled.span`
  color: var(--color-i-black);
  font-size: ${Fonts.H6};
  font-weight: ${Fonts.HEAVY};
`;

const LocationButtonMapImageWrapper = styled.div`
  display: flex;
  align-items: end;
  justify-content: end;
  position: absolute;
  right: 0;
`;

const CentreListContainer = styled.div`
  width: 100%;
  margin-top: ${Spacings.SPACING_10B};
  ${mediaQuery.uptoMobile} {
    margin-top: ${Spacings.SPACING_6B};
  }
`;

const CentreListWrapper = styled.div`
  width: 100%;
  columns: 4;
  ${mediaQuery.uptoMobile} {
    columns: 1;
  }
`;

const SubtitleContainer = styled.div`
  color: var(--color-i-black);
  font-size: ${Fonts.H5};
  font-weight: ${Fonts.LIGHT};
  ${mediaQuery.uptoMobile} {
    font-size: ${Fonts.H6};
  }
`;

const AllCentreList = ({ allCenterListData, onLocationButtonClick }) => {
  const title = allCenterListData?.title;
  const subtitle = allCenterListData?.subtitle;
  const centreList = allCenterListData?.data;
  const userPrevLoc = JSON.parse(localStorage.getItem('userLocation')) || {};
  const deepCopyCentreList = JSON.parse(JSON.stringify(centreList));
  const updatedCentreList = deepCopyCentreList.map((currState) => {
    const updatedStateCentreList = currState.centres.filter((centre) => {
      return centre?.availableUids?.length >= 1;
    });
    return { ...currState, centres: updatedStateCentreList };
  });

  return (
    <Wrapper>
      <Container>
        <TitleWrapper>
          <Typography variant="h2">{title}</Typography>
          <SubtitleContainer>{subtitle}</SubtitleContainer>
        </TitleWrapper>
        {(!userPrevLoc.lat || !userPrevLoc.long) && (
          <LocationButtonContainer onClick={onLocationButtonClick}>
            <Image
              src="allCentre/allCentreLocationIconBlack.svg"
              width={18}
              height={18}
              alt="Location Icon"
            />
            <LocationButtonTextWrapper>
              Find a centre near you
            </LocationButtonTextWrapper>
            <LocationButtonMapImageWrapper>
              <Image
                src="allCentre/LocationButtonMapImage.svg"
                width={65}
                height={65}
                alt="Map Image"
              />
            </LocationButtonMapImageWrapper>
          </LocationButtonContainer>
        )}
        <CentreListContainer>
          <CentreListWrapper>
            {updatedCentreList
              .filter((state) => {
                return state.centres.length > 0;
              })
              .map((centreData, index) => {
                return (
                  <CentreItem data={centreData} key={`state_item_${index}}`} />
                );
              })}
          </CentreListWrapper>
        </CentreListContainer>
      </Container>
    </Wrapper>
  );
};

export default AllCentreList;
